import React from "react";
import "../App.css";

const Home = () => {


    return (
        <section title="home-section">
            <div id="home" className="home-page">
                <div className="intro-container">
                    <h1>Hello, I'm <span className="text-link">Ryan</span></h1>
                    <h4 className="underline">Full-Stack Developer</h4>
                    <p>Seattle, WA</p>
                </div>
            </div>
        </section>
    )
}

export default Home;